import { render, staticRenderFns } from "./reporte-tag.vue?vue&type=template&id=9808067e&scoped=true&"
import script from "./reporte-tag.vue?vue&type=script&lang=js&"
export * from "./reporte-tag.vue?vue&type=script&lang=js&"
import style0 from "./reporte-tag.vue?vue&type=style&index=0&id=9808067e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9808067e",
  null
  
)

export default component.exports